import { Grid, makeStyles, Theme, useMediaQuery, useTheme } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { ResilienceLevel, ResilienceResponse } from "../../../../api/smartmelts-api/graphql/generated";
import { AttentionIcon } from "../../../../assets/icons/attention-icon";
import { InfoBox } from "../components/info-box";
import {
  IResilienceResultBoxProps,
  ResilienceResultBox,
  ResilienceResultBoxLastIconType,
} from "./resilience-result-box";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  infoBox: {
    maxWidth: 316,

    [theme.breakpoints.only("sm")]: {
      maxWidth: 250,
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: 250,
    },
  },
}));

interface IResilienceResultsProps {
  resilience: ResilienceResponse;
}

export const ResilienceResults: FunctionComponent<IResilienceResultsProps> = (props) => {
  const { resilience } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));

  const boxes: IResilienceResultBoxProps[] = [
    {
      title: t("mental_health.resilience.stress.title"),
      content: t(`mental_health.resilience.stress.descriptions.${resilience.stress}`),
      result: resilience.stress,
      lastIcon: ResilienceResultBoxLastIconType.WORRIED,
    },
    {
      title: t("mental_health.resilience.impulsiveness.title"),
      content: t(`mental_health.resilience.impulsiveness.descriptions.${resilience.impulsiveness}`),
      result: resilience.impulsiveness,
      lastIcon: ResilienceResultBoxLastIconType.WORRIED,
    },
    {
      title: t("mental_health.resilience.emotion.title"),
      content: t(`mental_health.resilience.emotion.descriptions.${resilience.emotion}`),
      result: resilience.emotion,
      lastIcon: ResilienceResultBoxLastIconType.WORRIED,
    },
  ];

  return (
    <Grid container className={classes.container} spacing={4} justify={isXs || isMd ? "center" : "flex-start"}>
      {boxes.map(
        (props, idx) =>
          props.result !== ResilienceLevel.NONE && (
            <Grid item key={`resilience-result-box-${idx}`}>
              <ResilienceResultBox {...props} />
            </Grid>
          ),
      )}
      <Grid item xs={12} sm md={12} lg className={classes.infoBox}>
        <InfoBox icon={AttentionIcon} text={t(`mental_health.resilience.warning`)} />
      </Grid>
    </Grid>
  );
};
